var Events = {
    SERVER_ERROR: 'internal-server-error',
    API_ERROR_HANDLER: 'api-error-handler',
    TIMEOUT: 'timeout',
    NOT_FOUND: 'not-found',
    NOTIFICATION: 'notification',
    STORED_DATA_LOAD: 'stored-data-load',
    NOTIFICATION_MODAL_CLOSE: 'notification-modal-close',
    NOTIFICATION_CLOSE: 'notification-close',
    PATHNAME_CHANGE: 'pathname-change',
    VERIFICATION_MODAL_OPEN: 'verification-modal-open',
    VERIFICATION_MODAL_CLOSE: 'verification-modal-close',
    VERIFICATION_SUCCESS: 'verification-success',
    VERIFICATION_MODAL_RESEND_CODE: 'verification-modal-resend-code',
    TRIGGER_DATA_LAYER_PUSH: 'trigger-data-layer-push'
};
export default Events;
